import React, { useEffect, useRef, useState } from "react";
import { STATUS } from "react-joyride";

const useChatbot = () => {
    const joyrideRef = useRef();

    const [run, setRun] = useState(false);

    useEffect(() => {
        // Check if the tour has been seen before
        const hasSeenTour = localStorage.getItem("guideTourChatbot");
        if (hasSeenTour !== "true") {
            setRun(true);
        }
        // Disable scrolling when the tour is running
        if (run && joyrideRef.current) {
            document.body.style.overflow = "hidden";
        }
    }, [run]);

    const handleJoyrideCallback = (data) => {
        const { status, action } = data;
        if (action === "close") {
            setRun(false);
            localStorage.setItem("guideTourChatbot", "true");
            document.body.style.overflow = "auto";
            return;
        }
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            localStorage.setItem("guideTourChatbot", "true");
            setRun(false);
            document.body.style.overflow = "auto";
        }
    };

    return {
        ref: {
            joyrideRef,
        },
        state: {
            run,
        },
        handlers: {
            handleJoyrideCallback,
        },
    };
};

export default useChatbot;
